import GlobalUtil from '../../utils/pricetravel/shared/globalUtil';
export default class AlgoliaTracker {
    constructor() {
        this.fn = window.__pt.fn || {};
        let _globalUtil = new GlobalUtil();
        this._userKey = _globalUtil.getUserKey();


    }
    clickedObjectIDsAfterSearch(objectIDs, indexName, item) {
        if (!window.aa) {
            return;
        }
        const eventData = {
            userToken: this._userKey,
            eventType: "click",
            index: indexName,
            eventName: 'Hit Clicked',
            queryID: item.queryId,
            objectIDs: objectIDs,
            positions: [item.position]
        };

        if (eventData.index && eventData.index.length) {
            window.aa('clickedObjectIDsAfterSearch', eventData);
        }

        return eventData;
    }



    clickedObjectIDs(item, index) {
        if (!item || !item.items || !item.items.queryID || !item.items.objectID || !window.aa) {
            return;
        }

        const authenticatedUserToken = "";
        const { queryID, objectID, } = item.items;

        const eventData = {
            userToken: this._userKey,
            authenticatedUserToken: authenticatedUserToken || "",
            index: config.algoliaSearch,
            eventName: 'Buscador Click',
            queryID: queryID,
            objectIDs: [objectID]
        };

        window.aa('clickedObjectIDs', eventData);
    }
    //filtro envadoi al seleccionar un filtro
    clickedFilters(indexName, filters, group) {
        if (window.aa) {
            window.aa('clickedFilters', {
                userToken: this._userKey,
                index: indexName,
                eventName: group + ' Clicked',
                filters: filters
            });
        }
    }
    //filtro enviado al cargar todos los filtros
    viewedFilters(indexName, filters, group) {
        if (window.aa) {
            aa('viewedFilters', {
                userToken: this._userKey,
                index: indexName,
                eventName: group + ' Viewed',
                filters: filters
            });
        }
    }
    convertedObjectIDsAfterSearch(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('convertedObjectIDsAfterSearch', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                index: config.algoliaSearch,
                eventName: 'Buscador Click',
                queryID: queryid,
                objectIDs: [objectid],
            });
        }
    }
    convertedObjectIDs(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('convertedObjectIDs', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                index: config.algoliaSearch,
                eventName: 'Buscador Click',
                objectIDs: [objectid],
            });
        }
    }
    convertedFilters(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('convertedFilters', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                index: config.algoliaSearch,
                eventName: 'Buscador Click',
                filters: [objectid],
            });
        }
    }
    addedToCartObjectIDsAfterSearch(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('addedToCartObjectIDsAfterSearch', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                eventName: 'Buscador Click',
                index: config.algoliaSearch,
                queryID: queryid,
                objectIDs: [objectid],
                objectData: [objectid],
                value: "",
                currency: ""
            });
        }
    }
    addedToCartObjectIDs(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('addedToCartObjectIDs', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                eventName: 'Buscador Click',
                index: config.algoliaSearch,
                queryID: queryid,
                objectIDs: [objectid],
                objectData: [objectid],
                value: "",
                currency: ""
            });
        }
    }
    purchasedObjectIDsAfterSearch(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('purchasedObjectIDsAfterSearch', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                eventName: 'Buscador Click',
                index: config.algoliaSearch,
                queryID: queryid,
                objectIDs: [objectid],
                objectData: [objectid],
                value: "",
                currency: ""
            });
        }
    }
    purchasedObjectIDs(item, index) {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa) {
            let objectid = item.items.objectID;
            let queryid = item.items.queryID;

            window.aa('purchasedObjectIDs', {
                userToken: this._userKey,
                authenticatedUserToken: "",
                eventName: 'Buscador Click',
                index: config.algoliaSearch,
                queryID: queryid,
                objectIDs: [objectid],
                objectData: [objectid],
                value: "",
                currency: ""
            });
        }
    }
    //evento lanzado al cargar la lista de resultados
    viewedObjectIDs(objectIDs, indexName) {
        if (window.aa) {
            window.aa('viewedObjectIDs', {
                userToken: this._userKey,
                eventName: "Hits Viewed",
                eventType: "view",
                index: indexName,
                objectIDs: objectIDs,
            });
        }
    }
    trackEvent(eventName, eventData) {
        if (window.aa) {
            window.aa(eventName, eventData);
        }
    }

}